import { RecordsTable } from "dyl-components";
import { useSelector } from "react-redux";
import OutstandingInvoicesTableHeader from "./OutstandingInvoicesTableHeader";
import OutstandingInvoice from "./OutstandingInvoice";
import QuoteBuilderModal from "shared/modals/QuoteBuilderModal";
import QuoteBuilderProvider from "shared/context/QuoteBuilderProvider";
import { useController, useFormContext } from "react-hook-form";

const OutstandingInvoicesTable = ({ customer_id, isAdmin }) => {
    const { invoices, isReadingOutstandingInvoices } = useSelector(state => ({
        invoices: state.subscription.outstanding_invoices,
        isReadingOutstandingInvoices: state.subscription.isReadingOutstandingInvoices
    }));

    const { control } = useFormContext();
    const { field: amountField } = useController({
        control,
        name: "amount",
    });

    return (
        <QuoteBuilderProvider>
            <RecordsTable
                tableBodyClassName="OutstandingInvoicesTable"
                isTableLoading={isReadingOutstandingInvoices}
                isTableEmpty={invoices.length === 0}
                TableHeader={<OutstandingInvoicesTableHeader />}
                TableRows={invoices.map((invoice) => (
                    <OutstandingInvoice
                        key={invoice.invoice_id}
                        id={invoice.invoice_id}
                        amount_due={invoice.amount_due}
                        date={invoice.created}
                        name={invoice.invoice_name}
                        status={invoice.invoice_status}
                        isAdmin={isAdmin}
                        price_schedule={invoices?.price_schedule}
                        updateAmount={(invoicesToPay) => {
                            amountField.onChange({
                                target: {
                                    name: amountField.name,
                                    value: invoicesToPay.reduce((total, invoiceId) => {
                                        const invoice = invoices.find(listedInvoice => listedInvoice.invoice_id === invoiceId);
                                        return total + (invoice ? invoice.amount_due : 0);
                                    }, 0)
                                }
                            });
                        }}
                    />
                ))}
                recordsCount={invoices.length}
                hasPagination={false}
                recordsName="Invoice"
                emptySubtitle=" "
                emptyListTitle={"No Open Invoices"}
            />
            <QuoteBuilderModal 
                account_id={customer_id}
                isAdmin={isAdmin}
            />
        </QuoteBuilderProvider>
    );
};

export default OutstandingInvoicesTable;
